module.exports = [{
      plugin: require('/home/gitlab-runner/builds/qiMitHzs/0/jli/xiaoju-sites/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/gitlab-runner/builds/qiMitHzs/0/jli/xiaoju-sites/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
